import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
var HouseholdCountDisplay = function HouseholdCountDisplay(_ref) {
  var label = _ref.label,
    value = _ref.value;
  if (!isNumber(value) || value === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "household-count-display"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, label), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "household-".concat(label.toLowerCase())
  }, value));
};
HouseholdCountDisplay.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default HouseholdCountDisplay;
//# sourceMappingURL=index.js.map